module.exports = __webpack_public_path__ + "static/media/youtubeIcon.2f027ba9.svg";